import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { Type as WSType } from '../WSAccessLayer/redux';
import { Modal } from 'antd';
import { Type } from './redux';

const getClassroom = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.GET_CLASSROOM),
    switchMap(({ classroomId }) =>
      fetch({
        url: '/mm-classroom/web/j/mocTermClassroomRpcBean.getClassroomById.rpc',
        body: {
          classroomId,
        },
      }),
    ),
    map(classroom => {
      if (classroom.supportAi === 1) {
        // AI课堂要先校验先权限
        return {
          type: Type.HAS_CLASSROOM_AUTH,
          classroom,
        };
      }
      return {
        type: Type.GET_CLASSROOM_SUCCESS,
        classroom,
      };
    }),
  );
const hasClassroomAuth = (action$, state$, { fetch }) => {
  let currentClassromm;
  return action$.pipe(
    ofType(Type.HAS_CLASSROOM_AUTH),
    switchMap(({ classroom }) => {
      currentClassromm = classroom;
      return fetch({
        url: '/mm-classroom/web/j/classroomManageBean.hasClassroomAuth.rpc',
        body: {
          classroomId: classroom?.classroomId,
        },
      });
    }),
    map(res => {
      if (res) {
        return {
          type: Type.GET_CLASSROOM_SUCCESS,
          classroom: currentClassromm,
        };
      }
      Modal.error({
        title: '抱歉，您暂无课堂权限',
        okText: '返回首页',
        onOk: () => {
          location.href = '//icourse163.org';
        },
      });
    }),
  );
};

const getOffLineClassrooms = (action$, state$, { fetch }) => {
  let requestQuery;
  return action$.pipe(
    ofType(Type.GET_OFF_LINE_CLASSROOMS),
    switchMap(({ query }) => {
      requestQuery = query;
      return fetch({
        // url:
        //   '/mm-classroom/web/j/mocTermClassroomRpcBean.getOffLineClassroomsByTermIdList.rpc',
        url:
          '/mm-classroom/web/j/mocTermClassroomRpcBean.getOffLineClassroomsWithAi.rpc',
        body: { ...query },
        withCredentials: true,
      });
    }),
    map(res => ({
      type: Type.GET_OFF_LINE_CLASSROOMS_SUCCESS,
      res,
      requestQuery,
    })),
  );
};

const createLesson = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.CREATE_LESSON),
    switchMap(({ classroomId }) =>
      fetch({
        url: '/mm-classroom/web/j/classroomManageBean.createLessonroom.rpc',
        body: {
          classroomId,
        },
      }),
    ),
    map(res => ({
      type: Type.CREATE_LESSON_SUCCESS,
      res,
    })),
  );
const getQRCode = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.GET_QR_CODE),
    switchMap(({ classroomId, width, height }) =>
      fetch({
        url: '/mm-classroom/web/j/appletBean.getQRCode.rpc',
        body: {
          classroomId,
          width,
          height,
        },
      }),
    ),
    map(res => ({
      type: Type.GET_QR_CODE_SUCCESS,
      res,
    })),
  );

const getAiClassrooms = (action$, state$, { fetch }) => {
  let requestQuery;
  return action$.pipe(
    ofType(Type.GET_AI_CLASSROOMS),
    switchMap(({ query }) => {
      requestQuery = query;
      return fetch({
        url: '/mm-classroom/web/j/mocClassroomMobBean.pageTerm.rpc',
        body: { ...query },
        withCredentials: true,
      });
    }),
    map(res => ({
      type: Type.GET_AI_CLASSROOMS_SUCCESS,
      res,
      requestQuery,
    })),
  );
};

export default [
  getClassroom,
  hasClassroomAuth,
  getOffLineClassrooms,
  createLesson,
  getQRCode,
  getAiClassrooms,
];
